

import { Fragment, useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Button, ButtonBase, Card, CardActionArea, Grid, IconButton, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import Request from '../../common/Request';
import { FancyCard, fancyCardSize } from './FancyCard';

// ----------------------------------------------------------------------


export default function SmallSumMetrics(props){

    const [metrics, setMetrics] = useState(null);

    useEffect(async () => {
        var req = await Request.Post(Request.Paths.ChartSumByEventType, props.filterData);

        if (req.ok && req.data.length > 0){
          setMetrics(req.data);
        }
        else
        {
            setMetrics(null);
        }

      }, [props.filterData]);
    console.log("metrics:", metrics);

    return <Fragment> { metrics != null && metrics.map( (m,i ) => {
            return <Grid  key={i} item  {... fancyCardSize}> 
              <FancyCard selected={m.Name == props.selectedMetric}  cardClicked={props.cardClicked}  metric={m} />  
            </Grid>;
           })} 
           </Fragment>
  
}

